import { DenominationTypes } from "../../constants/DenominationTypes";
import { roundToDecimals, toTitleCase } from "../../helpers/FormatHelper";
import { voidOrder } from "../../networking/NetworkingBankNotes";
import { getOrderConfirmation, getOrderFee, saveOrder, updateOrder } from "../../networking/NetworkingOrders";
import { getBNRate, getRateBNotes } from "../../networking/NetworkingRates";

export const calculateOrderRowAmount = (denominations, denominationType) =>{
    let amount = 0;
    if(denominations)
    {
        denominations.forEach((d)=>{          
          
            amount += (denominationType === DenominationTypes.notes)?d.DenominationValue*(d.NoNotes??0): d.NoNotes
        })
    }
    return amount;
} 

export const calculateOrderRowFee = (denominations) =>{
    let fee = 0;
    if(denominations)
    {
        denominations.forEach((d)=>{          
          
            fee += d.DenominationFee
        })
    }
    return fee;
}

 export const calculateBuyAmount = (fixedRateTerms, fixedCustomerRate
    , lockedSide, amount, buyScale
 ) => {
  let buyAmount = 0;
  if(fixedCustomerRate > 0)
  {
    if (fixedRateTerms === 'I') {
      //if (lockedSide.toLowerCase() === 'sell') {
        buyAmount = amount / fixedCustomerRate;
     
    } else {
     // if (lockedSide.toLowerCase() === 'sell') {
        buyAmount= amount * fixedCustomerRate;      
    }
  }
    return  roundToDecimals(buyAmount, buyScale);
  
  };

  export const calculateTotalAmounts = (orderRows) =>{
    let buyAmount = 0;
    let fee = 0;
    let profit = 0;
    if(orderRows)
    {
        orderRows.forEach((d)=>{
            buyAmount += d.BuyAmount;
                d.Denominations.forEach( d=>
                    fee += d.DenominationFee??0
                );
            profit += d.Profit;
        })
    }
    return {BuyAmount: buyAmount, Fee: fee, Profit: profit};
} 

const getDenominationsWithValueFormated = (denominations, denominationType) =>{

  const denominationCopy = JSON.parse(JSON.stringify(denominations)) ;
  const denominationsWithValue = denominationCopy.filter((d) => d.NoNotes > 0);
      denominationsWithValue.forEach((d) =>{
        d.NoNotes= (denominationType === DenominationTypes.amount)? d.NoNotes/d.DenominationValue : d.NoNotes
      } )
    return denominationsWithValue;
}

export const getRateAndAmounts = async(customerId, 
  valueDate, currencyID, rowAmount, lockedSide, denominations, denominationType, buyScale, buyCurrency)=>{

  const denominationsWithValue = getDenominationsWithValueFormated(denominations, denominationType);
    const rateResponse = await getRateBNotes(customerId, valueDate,currencyID, rowAmount, lockedSide, denominationsWithValue, buyCurrency);
    if(rateResponse)
    {
      if(rateResponse.Message && rateResponse.Message !== '')
      {
        return {BuyAmount: 0, CustomerRate: 0, RatePrecision: 0, FeeAmount: 0, ExpirationRate:0, Profit: 0, CostRate:0, Message: rateResponse.Message}
      }
      else
      {
        const amountByRate = calculateBuyAmount(rateResponse.RateTerms, rateResponse.CustomerRate, lockedSide, rowAmount, buyScale);
        const amountByCostRate = calculateBuyAmount(rateResponse.RateTerms, rateResponse.CostRate, lockedSide, rowAmount, buyScale);
        const profit = roundToDecimals(amountByRate - amountByCostRate, buyScale);
        const rowFee = calculateOrderRowFee(rateResponse.Denominations);

        return {RateTerms: rateResponse.RateTerms, BuyAmount: amountByRate, CustomerRate: rateResponse.CustomerRate, RatePrecision: rateResponse.RatePrecision, ExpirationRate: rateResponse.ValidForSeconds, Profit: profit, CostRate:rateResponse.CostRate, FeeAmount: rowFee, Denominations: rateResponse.Denominations}
      }
    }
    return {BuyAmount: 0, CustomerRate: 0, RatePrecision: 0, FeeAmount: 0, ExpirationRate:0, Profit: 0, CostRate:0}
}

export const getBNCrossRate = async(buyCurrency)=>{

    const request = {
        BuyCurrency:buyCurrency
    }
    const rateResponse = await getBNRate(request);
    if(rateResponse)
    {
      if(rateResponse.Message && rateResponse.Message !== '')
      {
        return {Rate: 0, Message: rateResponse.Message}
      }
      else
      {

        return {Rate: rateResponse.rate}
      }
    }
    return {Rate:0}
}

const getDenominationByRowToSave = (denominations, denominationType) => {
  const denominationsToSave = [] ;
  if(denominations)
  {
    denominations.forEach((d) =>{
      if(d.NoNotes > 0)
      {
        const den = {
              DenominationDescription: d.DenominationDescription,
              OrderedNoNotes: (denominationType === DenominationTypes.amount)? d.NoNotes/d.DenominationValue : d.NoNotes,
              OrderedAmount: (denominationType === DenominationTypes.amount)? d.NoNotes: d.NoNotes*d.DenominationValue,
              DenominationFee: d.DenominationFee,
              Status: "Pending"
            }
        denominationsToSave.push(den);
      }
    })
  }
  return denominationsToSave;
}
const getOrderRowsToSave = (orderRows) =>{

  const orderRowsToSave = [] ;
  if(orderRows)
  {
    orderRows.forEach((o, index) =>{
      const newOrder = {
        ItemNo: index+1,
        CurrencyID: o.CurrencyID,
        AmountOrdered: o.Amount,
        CostRate: o.CostRate,
        OriginalCustomerRate: o.Rate,
        CustomerRate: o.Rate,
        ItemProfit: o.Profit,
        ItemStatus: "Accepted",
        SettlementAmount: o.BuyAmount,
        BNOrderDenominations: o.MixedNotes?[]: getDenominationByRowToSave(o.Denominations, o.DenominationType)
      }
      orderRowsToSave.push(newOrder);
      })
  }
  return orderRowsToSave
}

const getOrderToSave = (objOrder, customerId, userID, lockedSide , contactId)=>
{
    const orderDate = new Date();
    console.log(orderDate.toDateString())

    const hours = String(orderDate.getHours()).padStart(2, '0');
    const minutes = String(orderDate.getMinutes()).padStart(2, '0');
    const seconds = String(orderDate.getSeconds()).padStart(2, '0');
    const baseCCy = localStorage.getItem('BaseCurrency');

    const showCompanyAddress = (lockedSide === 'buy' && objOrder.DeliveryMethod.toLowerCase().includes('sends currency'))

    return {
    BNOrderNo: objOrder.BNOrderNo > 0? objOrder.BNOrderNo : 0,
    CustomerId: customerId,
    ContactId: contactId,
    OrderDate: orderDate,
    OrderTime: `${hours}:${minutes}:${seconds}`,
    OrderedBy: userID,
    RequestedDeliveryDate: showCompanyAddress ? null: new Date(objOrder.DeliveryDate),
    RequestedDeliveryTime: showCompanyAddress ? null: `${objOrder.DeliveryTime}:00`,
    TotalOrder: objOrder.TotalOrder,
    TotalProfit: objOrder.TotalProfit,
    NoOfItems: objOrder.OrderRows.length,
    SettlementCurrencyID: objOrder.BuyCurrency,
    TotalFees: objOrder.OrderFee + objOrder.DeliveryFee + objOrder.DenominationFee,
    Status: "Accepted",
    DeliveryStatus: "Pending",
    SettlementStatus: "Outstanding",
    TotalSettled: 0,
    ShippedOn: null,
    ShippedBy: null,
    ShippingCompany: null,
    ReceivedOn: null,
    ReceivedBy: null,
    DeliveryFee: objOrder.DeliveryFee,
    OrderFee: objOrder.OrderFee,
    TotalDenominationsFees: objOrder.DenominationFee,
    DeliveryCustomerID: objOrder.DeliveryCustomerID,
    BuySell: toTitleCase(lockedSide),
    DeliveryMethod: objOrder.DeliveryMethod,
    Comments: objOrder.Comments,
    ParentOrderNo: objOrder.ParentOrderNo,
    CrossRate: (baseCCy !== objOrder.BuyCurrency) ? objOrder.CrossRate:0,
    BNOrderItems: getOrderRowsToSave(objOrder.OrderRows)
  }
}

export const save = async(objOrder, comments, customerId, userID, lockedSide, contactId) =>{
   
  objOrder.Comments = comments;

  const order = getOrderToSave(objOrder, customerId, userID, lockedSide, contactId);
    console.log(order);
  const responseSave = order.BNOrderNo > 0 ? await updateOrder(order): await saveOrder(order);

  console.log(responseSave);
  if(responseSave.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseSave.Message, Success: false, OrderNo:0}
  }
  else{
    const messageSave = order.BNOrderNo > 0 ?'Order was saved successfully': `Order was saved successfully. Order ID: ${responseSave.bnOrderNo} `
    return {Title: 'Success', Message: messageSave, Success: true, OrderNo: responseSave.bnOrderNo
    ,deliveryFeesMessage: responseSave.deliveryFeesMessage, newDeliveryFees: responseSave.newDeliveryFees, newDenominationFees: responseSave.newDenominationFees, 
    newOrderFees: responseSave.newOrderFees}
  }
}

export const getTotalOrderFee = async(customerID, totalOrder, lockedSide) =>{
   const response = await getOrderFee(customerID, totalOrder, lockedSide);

  if(response?.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: response?.Message, Success: false, TotalOrderFee:0}
  }
  else{
    return {Title: '', Message: '', Success: true, TotalOrderFee: response?.feeamount}
  }
}

export const getConfirmation = async(orderNo) =>{
  const responseConfirmation = await getOrderConfirmation(orderNo);
      const httpStatusCode = responseConfirmation.httpStatusCode;
      switch (httpStatusCode) {
        case 200:
          if (responseConfirmation != null && responseConfirmation.data != null) {
            const fileName = 'Order Confirmation ' + orderNo + '.pdf';
            const byteCharacters = atob(responseConfirmation.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const bytes = new Uint8Array(byteNumbers);
            const mimeType = 'application/pdf';//mime.lookup(fileName);
            const blob = new Blob([bytes], {
              type: mimeType 
            });
            
            return {Success: true, Title:'', Message:'', File:blob, FileName: fileName}
          }
          break;
        default:
          return {Success: false, Title:'Error', Message:'Please try again or contact the administrator',File:null, FileName:''}
          break;
      }
}

export const voidBNOrder = async(orderNo) =>{
  const responseOrder = await voidOrder(orderNo);

  console.log(responseOrder);
  if(responseOrder.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseOrder.Message, Success: false, OrderNo:0}
  }
  else{
    return {Title: 'Success', Message: 'Order was void successfully', Success: true}
  }
}